import api from './axiosInstance';

// ─── Type of Installation Master Data ───────────────────────────────────────

export const getTypesOfInstallation = () => api.get('/type-of-installation');
export const createTypeOfInstallation = (data) => api.post('/type-of-installation', data);
export const updateTypeOfInstallation = (id, data) => api.put(`/type-of-installation/${id}`, data);
export const deleteTypeOfInstallation = (id) => api.delete(`/type-of-installation/${id}`);
export const batchDeleteTypesOfInstallation = (ids) => api.post('/type-of-installation/batch-delete', { ids });

// ─── Linked Material IDs ─────────────────────────────────────────────────────

// Returns an array of materialIds that have at least one accessory linked
// (via either type-specific or base-level table).
export const getLinkedMaterialIds = () =>
  api.get('/material-accessories/linked-material-ids');

// Same set, but hydrated with name/unit/groupCode/department — used by the
// Download Selection panel so it never needs the full Material list.
export const getLinkedMaterials = () =>
  api.get('/material-accessories/linked-materials');

// ─── Material-Accessories Relationship ──────────────────────────────────────

// Get accessories for a specific material + type of installation combo
export const getForMaterialAndType = (materialId, typeOfInstallationId) =>
  api.get('/material-accessories', { params: { materialId, typeOfInstallationId } });

// Get all material-accessory-type combinations for a material
export const getByMaterial = (materialId) =>
  api.get(`/material-accessories/by-material/${materialId}`);

// Add accessories to a material + type combination
export const addToMaterial = (materialId, typeOfInstallationId, accessoryIds) =>
  api.post('/material-accessories', { materialId, typeOfInstallationId, accessoryIds });

// Remove accessories from a material + type combination
export const removeFromMaterial = (materialId, typeOfInstallationId, accessoryIds) =>
  api.delete('/material-accessories', { data: { materialId, typeOfInstallationId, accessoryIds } });

// ─── Material Base Accessories (Type-independent) ────────────────────────────

// Get base accessories for a material (no type required)
export const getBaseAccessories = (materialId) =>
  api.get('/material-base-accessories', { params: { materialId } });

// Link accessories to a material at the base level
export const addBaseAccessories = (materialId, accessoryIds) =>
  api.post('/material-base-accessories', { materialId, accessoryIds });

// Unlink accessories from a material at the base level
export const removeBaseAccessories = (materialId, accessoryIds) =>
  api.delete('/material-base-accessories', { data: { materialId, accessoryIds } });
